import React, { FC } from 'react'
import {
  Button,
  Dialog,
  DialogProps,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  Box
} from '@mui/material'
import { createStyles, makeStyles } from '@mui/styles'
import { Close } from '@mui/icons-material'
import { LoadingButton } from '../Button/LoadingButton'

interface Props extends DialogProps {
  open: boolean
  title?: string
  customTitle?: React.ReactNode
  hideHeader?: boolean
  loading?: boolean
  error?: string
  onClose?: () => void
  cancelButton?: {
    title: string
    action: () => void
    disabled?: boolean
  }
  successButton?: {
    title: string
    action: () => void
    disabled?: boolean
  }
  slim?: boolean
  footer?: React.ReactNode
}

export const Modal: FC<Props> = ({
  children,
  open,
  title,
  customTitle,
  hideHeader = false,
  loading,
  error,
  onClose,
  cancelButton,
  successButton,
  footer,
  slim = false,
  ...modalProps
}) => {
  const styles = useStyles()

  // Determinar qu� t�tulo mostrar
  const renderTitleContent = () => {
    if (customTitle !== undefined) {
      return customTitle
    }
    if (title) {
      return <Typography variant='h6'>{title}</Typography>
    }
    return null
  }

  const titleContent = renderTitleContent()
  const hasTitle = titleContent !== null

  return (
    <Dialog
      fullWidth={true}
      maxWidth='sm'
      {...modalProps}
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { borderRadius: '16px' } }}
    >
      {!hideHeader && (
        <DialogTitle className={styles.dialogTitle}>
          <Box
            display='flex'
            alignItems='center'
            justifyContent={hasTitle ? 'space-between' : 'flex-end'}
          >
            {titleContent}
            {onClose && (
              <IconButton onClick={onClose} style={{ color: 'white' }}>
                <Close />
              </IconButton>
            )}
          </Box>
        </DialogTitle>
      )}
      <DialogContent
        className={`${slim ? styles.slimDialog : ''} ${styles.dialogContent}`}
        sx={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}
      >
        {children}
        {error && (
          <Typography align='right' color='error'>
            {error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions className={slim ? styles.slimDialog : styles.dialogAction}>
        {cancelButton && (
          <Button
            variant='outlined'
            color='primary'
            onClick={cancelButton.action}
            disabled={cancelButton.disabled}
          >
            {cancelButton.title}
          </Button>
        )}
        {successButton && (
          <LoadingButton
            loading={loading}
            onClick={successButton.action}
            disabled={successButton.disabled}
          >
            {successButton.title}
          </LoadingButton>
        )}
      </DialogActions>
      {footer}
    </Dialog>
  )
}

const useStyles = makeStyles((theme: any) =>
  createStyles({
    dialogTitle: {
      margin: 0,
      padding: '6px 20px',
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      '& h6': {
        fontSize: '1rem',
        fontWeight: 450
      }
    },
    dialogAction: {
      display: 'flex',
      marginTop: 12
    },
    slimDialog: {
      padding: '0'
    },
    dialogContent: {
      paddingTop: '20px !important'
    }
  })
)
